import { USER_TYPE } from '../../Model/Enums';
import * as React from 'react';
import { useUserMenu } from './useUserMenu';

export const UserMenu = () => {
  const { role, signOut, navigateTo } = useUserMenu();
  return (
    <>
      <div className="d-flex flex-row gap-1">
        <div className="btn-group">
          <button type="button" className="btn btn-primary btn-lg">
            {role === USER_TYPE.ENTREPRENEUR && <span className="text-white">Vállalkozó</span>}
            {role === USER_TYPE.ACCOUNTANT && <span className="text-white">Könyvelő</span>}
          </button>
          <button
            type="button"
            className="btn btn-primary dropdown-toggle dropdown-toggle-split text-white"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span className="visually-hidden">Toggle Dropdown</span>
          </button>
          <ul className="dropdown-menu">
            <li>
              <div className="fw-bold mx-3">Beállítások</div>
              <ul className="list-unstyled p-2">
                <li>
                  <button className="dropdown-item" onClick={() => navigateTo('/token-management')}>
                    Hozzáférési kulcsok
                  </button>
                </li>
              </ul>
            </li>
            <div className="dropdown-divider"></div>
            <li>
              <button className="dropdown-item" onClick={signOut}>
                Kijelentkezés
              </button>
            </li>
          </ul>
        </div>
        <div>
          <a href="https://adriana.hu/" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">
            Tudjon meg többet
          </a>
        </div>
      </div>
    </>
  );
};
